import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Select,
} from 'antd';

import styles from './Saff.module.css'
import {
  getURLParams
} from '../../../helpers';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setFilter
} from '../../../actions';

const { Option } = Select;

class Saff extends PureComponent {
  render () {
    const defaultOption = 'All';
    const param = getURLParams(window.location);
    const value = param.saff ? param.saff : defaultOption;
    const {
      saffList,
      handleSaff,
      filters,
    } = this.props;

    return (
      (!!this.props.affList && !!filters.aff && (
        <div className={styles.saff}>
          <span className={styles.label}>Sub IDs:</span>
          <Select
            defaultValue={value}
            onChange={handleSaff}
            className={styles.control}
          >
            {!!saffList && saffList.map(({ saff, rowId }) => {
              const key = rowId !== undefined ? rowId : 'all';
              return (
                <Option
                  key={key}
                  value={saff === 'All' ? '' : saff}
                >
                  {saff}
                </Option>
              );
            })}
          </Select>
        </div>
      ))
    )
  }
}

Saff.propTypes = {
  affList: PropTypes.array.isRequired,
  saffList: PropTypes.array.isRequired,
};

Saff.defaultProps = {
  affList: [],
  saffList: [],
};

const mapStateToProps = (state) => ({
  filters: state.filters.filters,
  saffLoading: state.reports.saffLoading,
  affList: state.user.payload.affList,
  saffList: state.reports.saff,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setFilter,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Saff);
